import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, useLocalizedDate } from "@/components/site/shared";
import { ARTICLES } from "@/data/site";

const TAGS = ["all", "coffee", "pellets", "areca"];

export default function Insights() {
  const { t } = useTranslation();
  const fmtDate = useLocalizedDate();
  const [filter, setFilter] = useState("all");

  const filtered = filter === "all" ? ARTICLES : ARTICLES.filter((a) => a.tag === filter);

  return (
    <div data-testid="insights-page">
      <PageHero kicker={t("insights.kicker")} title={t("insights.title")} subtitle={t("insights.subtitle")} testId="insights-hero" />

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2" data-testid="insights-filters">
            {TAGS.map((tag) => (
              <button
                key={tag}
                onClick={() => setFilter(tag)}
                data-testid={`insights-filter-${tag}`}
                className={`border px-4 py-2 text-sm font-semibold transition-colors ${
                  filter === tag ? "bg-primary border-primary text-primary-foreground" : "bg-background hover:border-primary hover:text-primary"
                }`}
              >
                {tag === "all" ? t("insights.all") : t(`insights.tags.${tag}`)}
              </button>
            ))}
          </div>

          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((a) => (
              <Link to={`/insights/${a.id}`} key={a.id} className="group border bg-card overflow-hidden flex flex-col" data-testid={`article-card-${a.id}`}>
                <div className="aspect-video overflow-hidden">
                  <img src={a.image} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="bg-primary text-primary-foreground px-2 py-0.5 font-semibold uppercase tracking-wider">{t(`insights.tags.${a.tag}`)}</span>
                    <span>{fmtDate(a.date)}</span>
                    <span>· {a.minutes} {t("insights.minRead")}</span>
                  </div>
                  <h2 className="mt-3 font-heading text-lg font-bold leading-snug group-hover:text-primary transition-colors">{t(`articles.${a.id}.title`)}</h2>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed flex-1">{t(`articles.${a.id}.excerpt`)}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                    {t("insights.readMore")}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
